/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  BranchDiscrepancyTransferConfigResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get discrepancy transfer config based on branch type  for raising, disputing, settling discrepancies
 */
export const branchDiscrepancyTransferConfig = (
  branchType: 'DMB' | 'IND' | 'SP',
  signal?: AbortSignal,
) => {
  return customInstance<BranchDiscrepancyTransferConfigResponseResponse>({
    url: `/BboBranchConfigService/v1/branch-discrepancy-transfer-config/${branchType}`,
    method: 'get',
    signal,
  });
};

export const getBranchDiscrepancyTransferConfigQueryKey = (branchType: 'DMB' | 'IND' | 'SP') => {
  return [`/BboBranchConfigService/v1/branch-discrepancy-transfer-config/${branchType}`] as const;
};

export const getBranchDiscrepancyTransferConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof branchDiscrepancyTransferConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof branchDiscrepancyTransferConfig>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBranchDiscrepancyTransferConfigQueryKey(branchType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof branchDiscrepancyTransferConfig>>> = ({
    signal,
  }) => branchDiscrepancyTransferConfig(branchType, signal);

  return { queryKey, queryFn, enabled: !!branchType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof branchDiscrepancyTransferConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BranchDiscrepancyTransferConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof branchDiscrepancyTransferConfig>>
>;
export type BranchDiscrepancyTransferConfigQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get discrepancy transfer config based on branch type  for raising, disputing, settling discrepancies
 */
export const useBranchDiscrepancyTransferConfig = <
  TData = Awaited<ReturnType<typeof branchDiscrepancyTransferConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof branchDiscrepancyTransferConfig>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBranchDiscrepancyTransferConfigQueryOptions(branchType, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get discrepancy transfer config based on branch type  for raising, disputing, settling discrepancies
 */
export const branchDiscrepancyTransferConfigV2 = (
  branchType: 'DMB' | 'IND' | 'SP',
  signal?: AbortSignal,
) => {
  return customInstance<BranchDiscrepancyTransferConfigResponseResponse>({
    url: `/BboBranchConfigService/v2/branch-discrepancy-transfer-config/${branchType}`,
    method: 'get',
    signal,
  });
};

export const getBranchDiscrepancyTransferConfigV2QueryKey = (branchType: 'DMB' | 'IND' | 'SP') => {
  return [`/BboBranchConfigService/v2/branch-discrepancy-transfer-config/${branchType}`] as const;
};

export const getBranchDiscrepancyTransferConfigV2QueryOptions = <
  TData = Awaited<ReturnType<typeof branchDiscrepancyTransferConfigV2>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof branchDiscrepancyTransferConfigV2>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBranchDiscrepancyTransferConfigV2QueryKey(branchType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof branchDiscrepancyTransferConfigV2>>> = ({
    signal,
  }) => branchDiscrepancyTransferConfigV2(branchType, signal);

  return { queryKey, queryFn, enabled: !!branchType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof branchDiscrepancyTransferConfigV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BranchDiscrepancyTransferConfigV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof branchDiscrepancyTransferConfigV2>>
>;
export type BranchDiscrepancyTransferConfigV2QueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get discrepancy transfer config based on branch type  for raising, disputing, settling discrepancies
 */
export const useBranchDiscrepancyTransferConfigV2 = <
  TData = Awaited<ReturnType<typeof branchDiscrepancyTransferConfigV2>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof branchDiscrepancyTransferConfigV2>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBranchDiscrepancyTransferConfigV2QueryOptions(branchType, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
